import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { PostoService, EscalaService } from './domain-services';
import { Posto } from '@core/models/models';

@Injectable({ providedIn: 'root' })
export class CoberturaAlertService {
  private readonly postoSvc = inject(PostoService);
  private readonly escalaSvc = inject(EscalaService);

  private _postosSemCobertura = new BehaviorSubject<Posto[]>([]);
  postosSemCobertura$ = this._postosSemCobertura.asObservable();

  private _semCobertura = new BehaviorSubject<number>(0);
  semCobertura$ = this._semCobertura.asObservable();

  constructor() {
    this.refresh();
  }

  set(count: number): void {
    this._semCobertura.next(count);
  }

  refresh(): void {
    forkJoin({
      postos: this.postoSvc.getAll({ ativo: true, pageSize: 1000 } as Record<string, unknown>),
      escalas: this.escalaSvc.getAll({ ativas: true, pageSize: 1000 } as Record<string, unknown>)
    }).subscribe({
      next: res => {
        const todosPostos = res.postos.data || [];
        const escalasHoje = res.escalas.data || [];
        const postosComEscala = new Set(escalasHoje.map(e => e.idPosto));
        const semCobertura = todosPostos.filter(p => !postosComEscala.has(p.id!));
        this._postosSemCobertura.next(semCobertura);
        this._semCobertura.next(semCobertura.length);
      },
      error: err => {
        console.error('Erro ao calcular postos sem cobertura', err);
      }
    });
  }
}

